import { Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import useScrollAnimation from './hooks/useScrollAnimation';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './components/Main/HomePage/HomePage';
import SponsorsPage from './components/Main/SponsorsPage/SponsorsPage';
import AboutPage from './components/Main/AboutPage/AboutPage';
import SpeakersPage from './components/Main/SpeakersPage/SpeakersPage';

const App = () => {
  useScrollAnimation();

  return (
    <section className='app'>
       <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Header />

      <Routes>
          <Route path="/" element={ <HomePage /> } />
          <Route path="/speakers" element={ <SpeakersPage /> } />
          <Route path="/sponsors" element={ <SponsorsPage /> } />
          <Route path="/about" element={ <AboutPage /> } />
      </Routes>

      <Footer />
    </section>
  )
}

export default App